import {
    fetchOverview,
    fetchSignerTransactions
} from '../dashboardSlice';

export default function ssrFetch({
    store, headers, baseUrl, timeout
}) {
    const options = timeout ? {timeout} : {};

    return Promise.all([
        store.dispatch(fetchOverview({headers, baseUrl, options})),
        store.dispatch(fetchSignerTransactions({headers, baseUrl, options}))
    ]);
}
